/**
 * 加工廠 create／update 寫入 payload。
 * 禁止：status；addresses／contacts 巢狀 id（replace-all）。
 * warehouseIds：去重；必填由呼叫端／zod 保證非空。
 */
export function buildProcessingFactoryWritePayload(values, { updatedAt = null } = {}) {
  const warehouseIds = uniqueWarehouseIds(values?.warehouseIds);

  const payload = {
    code: values?.code,
    name: values?.name,
    chineseName: values?.chineseName ?? null,
    englishName: values?.englishName ?? null,
    taxIdNumber: values?.taxIdNumber ?? null,
    homepage: values?.homepage ?? null,
    phone: values?.phone ?? null,
    fax: values?.fax ?? null,
    warehouseIds,
    remark: values?.remark ?? null,
    addresses: (values?.addresses ?? []).map(mapAddressForWrite),
    contacts: (values?.contacts ?? []).map(mapContactForWrite),
  };

  if (updatedAt != null && updatedAt !== '') {
    payload.updatedAt = updatedAt;
  }

  return payload;
}

function uniqueWarehouseIds(ids = []) {
  const seen = new Set();
  const out = [];
  (ids ?? []).forEach((id) => {
    if (id == null || id === '') {
      return;
    }
    if (seen.has(id)) {
      return;
    }
    seen.add(id);
    out.push(id);
  });
  return out;
}

function mapAddressForWrite(row) {
  return {
    lineNo: row?.lineNo,
    addressType: row?.addressType ?? null,
    postalCode: row?.postalCode ?? null,
    city: row?.city ?? null,
    district: row?.district ?? null,
    address: row?.address,
    isDefault: Boolean(row?.isDefault),
    remark: row?.remark ?? null,
  };
}

function mapContactForWrite(row) {
  return {
    lineNo: row?.lineNo,
    name: row?.name,
    department: row?.department ?? null,
    title: row?.title ?? null,
    phone: row?.phone ?? null,
    mobile: row?.mobile ?? null,
    email: row?.email ?? null,
    isDefault: Boolean(row?.isDefault),
    remark: row?.remark ?? null,
  };
}
